import { Button } from '../../components/Button';
import { ListItemCard } from '../../components/ListItemCard';
import { EditIcon } from '../../icons/EditIcon';
import { PlusIcon } from '../../icons/PlusIcon';
import { RemoveIcon } from '../../icons/RemoveIcon';
import { Actions } from './ExtrasListCard.styles';
import type { ExtrasListCardProps } from './ExtrasListCard.types';

export function ExtrasListCard({
  id,
  image,
  title,
  label,
  price,
  selected = false,
  quantity,
  onAdd,
  onRemove,
  onEditSelections,
  labels = {},
}: ExtrasListCardProps) {
  const {
    add = 'Add',
    remove = 'Remove',
    quantity: quantityLabel = 'Quantity',
    editSelections = 'Edit selections',
  } = labels;

  const secondaryLine = selected && quantity ? `${quantityLabel} ${quantity}` : label;

  const actions = (
    <Actions>
      {selected && onEditSelections && (
        <Button
          type="button"
          variant="icon"
          size="small"
          onClick={onEditSelections}
          aria-label={editSelections}
        >
          <EditIcon size={24} />
        </Button>
      )}
      <Button
        type="button"
        variant="primary"
        size="small"
        onClick={selected ? onRemove : onAdd}
        aria-label={selected ? remove : add}
      >
        {selected ? <RemoveIcon size={13} /> : <PlusIcon size={13} />}
      </Button>
    </Actions>
  );

  return (
    <ListItemCard
      id={id}
      name={title}
      label={secondaryLine}
      image={image}
      price={price}
      actions={actions}
      stackedRight
      stackedBelow
    />
  );
}
